(() => {
  "use strict";
  if (window.SupplyMeCartState) return;
  const MEMBERSHIP_PRODUCT_TYPE = "membership";
  const CHANGE_EVENT = "supplyme:cart-state:changed";
  let cartPromise = null;
  let refreshTimer = null;
  function routesRoot() { return window.Shopify?.routes?.root || "/"; }
  function isMembershipItem(item) {
    return String(item?.product_type || "").trim().toLowerCase() === MEMBERSHIP_PRODUCT_TYPE;
  }
  function membershipItems(cart) { return (cart?.items || []).filter(isMembershipItem); }
  function containsMembership(cart) { return membershipItems(cart).length > 0; }
  function normalize(cart) {
    const memberships = membershipItems(cart);
    return { cart, containsMembership: memberships.length > 0, membershipItems: memberships };
  }
  async function load({ force = false } = {}) {
    if (cartPromise && !force) return cartPromise;
    cartPromise = fetch(`${routesRoot()}cart.js`, {
      method: "GET", credentials: "same-origin", headers: { Accept: "application/json" }
    }).then((response) => {
      if (!response.ok) throw new Error("Unable to read cart");
      return response.json();
    }).catch((error) => { cartPromise = null; throw error; });
    return cartPromise;
  }
  function invalidate() { cartPromise = null; }
  function publish(cart) {
    const state = normalize(cart);
    document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: state }));
    return state;
  }
  async function refresh() { invalidate(); return publish(await load({ force: true })); }
  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(() => { refresh().catch(() => {}); }, 100);
  }
  window.SupplyMeCartState = Object.freeze({
    CHANGE_EVENT, containsMembership, invalidate, isMembershipItem, load,
    membershipItems, normalize, publish, refresh, scheduleRefresh
  });
  document.addEventListener("on:cart:add", scheduleRefresh);
  document.addEventListener("on:line-item:change", scheduleRefresh);
  document.addEventListener("supplyme:physical-bonus:cart-changed", scheduleRefresh);
  window.addEventListener("pageshow", (event) => { if (event.persisted) scheduleRefresh(); });
})();
